import { get as lodashGet, findIndex, isNumber } from 'lodash';
import { UNCHECK_ITEM } from '../../../graphql/shopping-list';
import { UndoAction } from './Action';
import CheckItemAction from './CheckItemAction';
import DeleteItemAction from './DeleteItemAction';

/* eslint-disable no-underscore-dangle */

class UncheckItemAction extends UndoAction {
  constructor(options) {
    super(options);
    this.item = options.item;
    this.index = options.index;
    this.newIndex = lodashGet(this.undoAction, 'index');
  }

  static get name() { return 'UncheckItemAction'; }

  _executeImpl() {
    const shoppingList = this.component.shoppingList;

    // If item already exists on unchecked list, just delete it
    if (findIndex(shoppingList.items.unchecked, { externalId: this.item.externalId }) >= 0) {
      return this.component.triggerAction(DeleteItemAction, {
        index: this.index,
        itemListName: 'checked',
      });
    }

    const self = this;
    return this.component.$apollo.mutate({
      mutation: UNCHECK_ITEM,
      variables: {
        id: shoppingList.id,
        itemId: this.item.id,
        newIndex: this.newIndex,
      },
      update(store, { data: { shoppingListUncheckItem } }) {
        self._updateCache(store, shoppingListUncheckItem);
      },
      optimisticResponse: {
        shoppingListUncheckItem: {
          __typename: 'ShoppingListUncheckItemResult',
          item: {
            ...this.item,
          },
          modifiedAt: null,
        },
      },
    });
  }

  updateQuery(cachedShoppingList, shoppingListUncheckItemResult) {
    cachedShoppingList.items.checked.splice(this.index, 1);
    if (isNumber(this.newIndex)) {
      cachedShoppingList.items.unchecked.splice(this.newIndex, 0,
        shoppingListUncheckItemResult.item);
    } else {
      cachedShoppingList.items.unchecked.push(shoppingListUncheckItemResult.item);
    }
  }

  undo() {
    const index = findIndex(this.component.shoppingList.items.unchecked, { id: this.item.id });
    if (index < 0) {
      throw new Error('Uncheck item undo failed, item not found.');
    }

    return this.component.triggerAction(CheckItemAction, {
      index,
      item: this.component.shoppingList.items.unchecked[index],
      undoAction: this,
    });
  }

  updateItem(oldItem, newItem) {
    if (this.item.id === oldItem.id) {
      this.item = newItem;
    }
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo uncheck item'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo uncheck item'; }
}

export default UncheckItemAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/UncheckItemAction.js